import { INotification, TargetComponent, NotificationLevel, DismissMode, ScopeLevel, IContext } from '../../types';
import { i18nMap, shouldRender, isAvailable, isBillingLinkPermission } from '../../utils';

export class DeprecateSyndicationSearchOnlyNotification {
  context: IContext;
  i18n: any;
  availableScopes: ScopeLevel[];

  constructor(context: IContext) {
    this.context = context;
    this.i18n = context.getNewI18n();
    this.availableScopes = [ScopeLevel.account];
  }

  async getDeprecateSyndicationSearchOnlyNotifications() {
    if (!this.context.getUserContext().CurrentUser.IsInternal && isBillingLinkPermission(this.context.getSettingsContext())) {
      return [];
    }

    const {
      DeprecateSyndicationSearchOnly,
      SyndicationSearchOnlyWhitelist,
    } = this.context.getCurrentPermissions().dynamic;

    if (!DeprecateSyndicationSearchOnly || SyndicationSearchOnlyWhitelist) {
      return [];
    }

    if (!isAvailable(this.context.getCurrentScope(), this.availableScopes)) {
      return [];
    }

    if (!shouldRender(ScopeLevel.account, this.context.getChangeScope())) {
      return [];
    }

    const notifications: INotification[] = [];

    notifications.push({
      id: 'DeprecateSyndicationSearchOnly',
      condition: true,
      target: TargetComponent.UnifiedQueue,
      dismissMode: DismissMode.permanent,
      severity: NotificationLevel.Info,
      scopeLevel: ScopeLevel.account,
      availableScopes: this.availableScopes,
      title: this.i18n.getString(i18nMap.UnifiedNotificationQueue_DeprecateSyndicationSearchOnly_Update_Title),
      message: this.i18n.getString(i18nMap.UnifiedNotificationQueue_DeprecateSyndicationSearchOnly_Update_Message),
      actionList: [
        {
          text: this.i18n.getString(_TL_('Learn more')),
          action: () => {
            window.open('https://help.ads.microsoft.com/#apex/ads/en/60146/0', '_blank');
          },
          callbackType: 'closeQueue',
          extraClassNames: undefined,
          extraAttrs: undefined,
        },
      ],
    });

    return notifications;
  }
}
